import { defineService, implementService } from '@wix/services-manager/helpers'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import { createExternalLinkUtils } from './linkUtils'
import type { LinkUtilsConfig, LinkUtils } from './types'

export const LinkUtilsServiceDefinition = defineService<LinkUtils>('LinkUtils')

export const LinkUtilsService = implementService(
	LinkUtilsServiceDefinition,
	({ config }: ServiceFactoryOpts<LinkUtilsConfig>) => createExternalLinkUtils(config)
)
